
export const DRIVERS_2026 = [
  { num:1,  acronym:'VER', name:'Max Verstappen',    team:'Red Bull Racing', colour:'#3671C6', nat:'🇳🇱' },
  { num:4,  acronym:'NOR', name:'Lando Norris',      team:'McLaren',         colour:'#FF8000', nat:'🇬🇧' },
  { num:16, acronym:'LEC', name:'Charles Leclerc',   team:'Ferrari',         colour:'#E8002D', nat:'🇲🇨' },
  { num:44, acronym:'HAM', name:'Lewis Hamilton',    team:'Ferrari',         colour:'#E8002D', nat:'🇬🇧' },
  { num:81, acronym:'PIA', name:'Oscar Piastri',     team:'McLaren',         colour:'#FF8000', nat:'🇦🇺' },
  { num:63, acronym:'RUS', name:'George Russell',    team:'Mercedes',        colour:'#27F4D2', nat:'🇬🇧' },
  { num:12, acronym:'ANT', name:'Kimi Antonelli',    team:'Mercedes',        colour:'#27F4D2', nat:'🇮🇹' },
  { num:30, acronym:'LAW', name:'Liam Lawson',       team:'Red Bull Racing', colour:'#3671C6', nat:'🇳🇿' },
  { num:14, acronym:'ALO', name:'Fernando Alonso',   team:'Aston Martin',    colour:'#229971', nat:'🇪🇸' },
  { num:18, acronym:'STR', name:'Lance Stroll',      team:'Aston Martin',    colour:'#229971', nat:'🇨🇦' },
  { num:55, acronym:'SAI', name:'Carlos Sainz',      team:'Williams',        colour:'#64C4FF', nat:'🇪🇸' },
  { num:23, acronym:'ALB', name:'Alexander Albon',   team:'Williams',        colour:'#64C4FF', nat:'🇹🇭' },
  { num:10, acronym:'GAS', name:'Pierre Gasly',      team:'Alpine',          colour:'#FF87BC', nat:'🇫🇷' },
  { num:7,  acronym:'DOO', name:'Jack Doohan',       team:'Alpine',          colour:'#FF87BC', nat:'🇦🇺' },
  { num:22, acronym:'TSU', name:'Yuki Tsunoda',      team:'Racing Bulls',    colour:'#6692FF', nat:'🇯🇵' },
  { num:6,  acronym:'HAD', name:'Isack Hadjar',      team:'Racing Bulls',    colour:'#6692FF', nat:'🇫🇷' },
  { num:31, acronym:'OCO', name:'Esteban Ocon',      team:'Haas F1 Team',    colour:'#B6BABD', nat:'🇫🇷' },
  { num:87, acronym:'BEA', name:'Oliver Bearman',    team:'Haas F1 Team',    colour:'#B6BABD', nat:'🇬🇧' },
  { num:27, acronym:'HUL', name:'Nico Hulkenberg',   team:'Kick Sauber',     colour:'#52E252', nat:'🇩🇪' },
  { num:5,  acronym:'BOR', name:'Gabriel Bortoleto', team:'Kick Sauber',     colour:'#52E252', nat:'🇧🇷' },
];

export const TEAMS_2026 = [
  { team:'Red Bull Racing', colour:'#3671C6', nat:'🇦🇹', drivers:['VER','LAW'] },
  { team:'Ferrari',         colour:'#E8002D', nat:'🇮🇹', drivers:['LEC','HAM'] },
  { team:'McLaren',         colour:'#FF8000', nat:'🇬🇧', drivers:['NOR','PIA'] },
  { team:'Mercedes',        colour:'#27F4D2', nat:'🇩🇪', drivers:['RUS','ANT'] },
  { team:'Aston Martin',    colour:'#229971', nat:'🇬🇧', drivers:['ALO','STR'] },
  { team:'Williams',        colour:'#64C4FF', nat:'🇬🇧', drivers:['SAI','ALB'] },
  { team:'Alpine',          colour:'#FF87BC', nat:'🇫🇷', drivers:['GAS','DOO'] },
  { team:'Racing Bulls',    colour:'#6692FF', nat:'🇮🇹', drivers:['TSU','HAD'] },
  { team:'Haas F1 Team',    colour:'#B6BABD', nat:'🇺🇸', drivers:['OCO','BEA'] },
  { team:'Kick Sauber',     colour:'#52E252', nat:'🇨🇭', drivers:['HUL','BOR'] },
];
